import { I_IQPlayerGalleryWrapper } from './interfaces';
import ReactDOM from 'react-dom';
import React from 'react';
import IQPlayerSliderApp from './iq-player-slider';

/**
 * entry point
 */
export const audioPlayerInit = () => {
    const placeholders = document.querySelectorAll('[data-iq-player-gallery]');

    for(const placeholder of placeholders) {
        const dataId = placeholder.getAttribute('data-id');

        const data = document.querySelectorAll(`[iq-player-gallery-data="${ dataId }"]`);
        if(!data?.length || !data[0]?.textContent)  return;

        let iqPlayerGalleryWrapper: I_IQPlayerGalleryWrapper|null = null;
        try {
            iqPlayerGalleryWrapper = JSON.parse(data[0].textContent);
        }
        catch (ex) {
            console.error('Parse data error', ex);
            return;
        }

        if (!iqPlayerGalleryWrapper) return;

        iqPlayerGalleryWrapper.iQPlayerGallery =
            iqPlayerGalleryWrapper.iQPlayerGallery.map((item, index) => ({
                ...item,
                runID: index + 1,
            }));

        placeholder.classList.remove('hidden');

        ReactDOM.render(
            <React.StrictMode>
                <IQPlayerSliderApp
                    iQPlayerGalleryWrapper={ iqPlayerGalleryWrapper }
                />
            </React.StrictMode>,
            placeholder,
        );
    }
};